import axios from "axios";

const requestMaker = axios.create(
    {baseURL: "https://api.themoviedb.org/3"}
);

export default requestMaker;